export default __webpack_public_path__ + "static/media/sides-building.905bdc69.webp";